export function clearLocalDataForToken(token: string) {
    // 1) Borrar entrada del token en el tokenMap (answers, scores, demographics)
    const raw = localStorage.getItem("NOM035_tokenMap");
    if (raw) {
        try {
            const map = JSON.parse(raw) || {};
            if (map[token]) {
                delete map[token];
                // Si quedó vacío, puedes limpiar el key completo; si no, reescribir
                if (Object.keys(map).length === 0) {
                    localStorage.removeItem("NOM035_tokenMap");
                } else {
                    localStorage.setItem("NOM035_tokenMap", JSON.stringify(map));
                }
            }
        } catch {
            // si algo raro pasa, preferimos eliminar el key completo para no dejar basura
            localStorage.removeItem("NOM035_tokenMap");
        }
    }

    // 2) Borrar marcadores de sección por guía (persistencia de navegación)
    ["GUIA_I", "GUIA_II", "GUIA_III"].forEach(k => {
        localStorage.removeItem(`NOM035_${k}_section`);
    });

    // 3) Borrar globals SOLO si pertenecen a este token
    if (localStorage.getItem("user-token") === token) {
        localStorage.removeItem("user-token");
        localStorage.removeItem("campaign");
        localStorage.removeItem("guia");
    }
}
